import { Outlet, useLocation } from "react-router-dom";
import { usePermissions } from "../helper/PermissionContext";
import AccessDenied from "../pages/AccessDenied/AccessDenied";

const ROUTE_PERMISSIONS = {
  "/": "dashboard", "/blog": "blog-management", "/add-blog": "blog-management",
  "/edit-blog": "blog-management", "/category": "blog-management", "/author": "blog-management",
  "/contact": "contact", "/business-contact": "Business-contact", "/faq": "faq-management",
  "/add-faq": "faq-management", "/edit-faq": "faq-management", "/seo": "seo-management",
  "/add-seo": "seo-management", "/edit-seo": "seo-management", "/global-seo": "global-seo",
  "/sitemap": "sitemap-management", "/llms": "llms-management", "/robots": "robots-management",
  "/email-management": "email-management", "/add-email-management": "email-management",
  "/edit-email-management": "email-management", "/users": "user-management", "/roles": "user-management",
  "/permissions": "user-management"
};

const permissionForPath = (pathname) => {
  if (pathname === "/") return ROUTE_PERMISSIONS["/"];
  return Object.entries(ROUTE_PERMISSIONS)
    .filter(([path]) => path !== "/")
    .find(([path]) => pathname === path || pathname.startsWith(`${path}/`))?.[1] || null;
};

export default function RoutePermissionGuard() {
  const { pathname } = useLocation();
  const { status, hasPermission } = usePermissions();
  if (status === "loading") return <div>Loading...</div>;
  const required = permissionForPath(pathname);
  return required && !hasPermission(required) ? <AccessDenied /> : <Outlet />;
}
